import { ErrorOutlineRounded } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

interface ReleaseChannelErrorModalProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

/**
 * Modal bloqueante exibido quando o canal de versão do app não bate com o do banco (ou o banco está off na validação).
 * Impede o usuário de entrar no Feed até reconhecer o erro.
 */
export function ReleaseChannelErrorModal({ open, message, onClose }: ReleaseChannelErrorModalProps) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      aria-labelledby="release-channel-error-title"
    >
      <DialogTitle id="release-channel-error-title">
        <Stack direction="row" alignItems="center" gap={1}>
          <ErrorOutlineRounded color="error" />
          <Typography variant="h6" component="span">
            Canal de versão incompatível
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1">{message}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          O Feed Manager não pode ser iniciado com esta combinação de versão e banco de dados.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose} autoFocus>
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function isReleaseChannelErrorResponse(error: { code?: string; message?: string } | null | undefined): boolean {
  return error?.code === 'release-channel';
}
